import { slug } from '../lib/text.ts';

/**
 * Identyfikatory nagrań bota. Plik: public/audio/<id>.mp3
 *   s.<id>        zdanie modelowe        s.<id>.slow   to samo wolniej
 *   v.<id>        wariant zdania         v.<id>.slow   wolniej
 *   w.<słowo>     pojedyncze słówko        w.<słowo>.slow   to samo wolniej (przycisk „Wolno” na karcie słowa)
 *   b.<id>        linijka bota (żart, pochwała, wskazówka)   b.<id>.pl  jej polska wersja (z pola `pl`)
 *   t.<klucz>.<en|pl>  fraza nauczyciela albo pochwała (src/content/teacher.json)
 *   l.<id lekcji>.<kod>  nagranie lekcji kursu v2 (id kroku `a1-001:d1` → `l.a1-001.d1`; bez dwukropków, żeby nazwa pliku była bezpieczna na każdym systemie)   …​.slow  wolniej
 *   f.<klucz>     uwaga bota po polsku (src/lib/feedbackVoice.ts): „Brawo!”, „Powiedz całe zdanie — brakuje:”, „Nic nie słyszę…”   f.<klucz>.en  ta sama fraza po angielsku
 */
export const audioIds = {
  sentence: (id: string) => `s.${id}`,
  sentenceSlow: (id: string) => `s.${id}.slow`,
  variant: (id: string) => `v.${id}`,
  variantSlow: (id: string) => `v.${id}.slow`,
  word: (word: string) => `w.${slug(word)}`,
  wordSlow: (word: string) => `w.${slug(word)}.slow`,
  banter: (id: string) => `b.${id}`,
  banterPl: (id: string) => `b.${id}.pl`,
  teacher: (key: string, lang: 'en' | 'pl') => `t.${key}.${lang}`,
  /** Kurs v2: `stepId` to id z `audioTexts` (np. `a1-001:s3`). */
  lesson: (stepId: string) => `l.${stepId.replace(/:/g, '.')}`,
  lessonSlow: (stepId: string) => `l.${stepId.replace(/:/g, '.')}.slow`,
  feedback: (key: string, lang: 'en' | 'pl' = 'pl') => (lang === 'en' ? `f.${key}.en` : `f.${key}`),
};

export function audioUrl(id: string, base = './'): string {
  return `${base}audio/${id}.mp3`;
}
